$(function() {
    $('.input-wrapper input').on('focus', function() {
        var $this = $(this);

        // if ($this.val() !== '') {
        $this.parent().addClass('focus');
        // }
    });
});
